import { ArticleMeta, articleTag } from "./types";

const META: ArticleMeta = {
    slug: "network-security-foundations",
    section: "briefing",
    header: "Security Engineering",
    title: "Network Security Foundations for Cloud-Native Systems",
    description: "Layered segmentation, identity-aware access, and encrypted service traffic, verified continuously.",
    tags: [
        articleTag("bitwarden.svg"),
        articleTag("cloudflare.svg"),
        articleTag("kubernetes.svg"),
        articleTag("openshift-svgrepo-com.svg"),
    ],
    url: "/articles/network-security-foundations",
};

export default META;
